var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1668764695957,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 14219,
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M661.942857 82.285714H146.285714c-20.114286 0-36.571429 16.457143-36.571428 36.571429v804.571428c0 20.114286 16.457143 36.571429 36.571428 36.571429h731.428572c20.114286 0 36.571429-16.457143 36.571428-36.571429V334.628571L661.942857 82.285714z",
    fill: "#F96464",
    "p-id": 14220
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M661.942857 298.057143c0 20.114286 16.457143 36.571429 36.571429 36.571428H914.285714L661.942857 82.285714v215.771429z",
    fill: "#F79797",
    "p-id": 14221
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M458.971429 689.371429c-9.142857 14.628571-23.771429 18.285714-36.571429 7.314285l-65.828571-54.857143c-16.457143-14.628571-43.885714-10.971429-54.857143 9.142858l-84.114286 140.8c-14.628571 23.771429 3.657143 54.857143 31.085714 54.857142h512c31.085714 0 47.542857-36.571429 27.428572-60.342857L592.457143 559.542857c-16.457143-18.285714-45.714286-16.457143-58.514286 5.485714l-74.971428 124.342858z",
    fill: "#FFF8F8",
    "p-id": 14222
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M786.285714 484.571429m-54.857143 0a54.857143 54.857143 0 1 0 109.714286 0 54.857143 54.857143 0 1 0-109.714286 0Z",
    fill: "#FFF8F8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img.09e709b3e2e745bbacd66f3eff19019f.svg";
export { ForwardRef as ReactComponent };